<template>
    <div name="hero" class="hero" id="hero">
        <div class="section-wrap">
            <div class="section section1">
                <div class="video-area">
                    <video autoplay muted loop class="bg-video">
                        <source src="../../assets/renew_pc/soldoc_main_pc.mp4" type="video/mp4">
                    </video>
                </div>
                
                <div class="title-wrap">
                    <span class="h-title"><span class="bold-title">모든 진료의 시작, 솔닥</span><br><span class="sub-text">진료 예약부터 처방, 진료 관리까지<br>
                            기다림 없이 한 번에</span></span>
                    <div class="btn-group-area">
                        <a href="https://apps.apple.com/kr/app/soldoc/id1667730511" target="_blank" title="새창으로 열림" class="btn-main-link">
                            <img class="ico" src="../../assets/renew_pc/ico-appstore.png" alt="app store"/>
                            <span class="text">App Store</span>
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.soldocapp" target="_blank" title="새창으로 열림" class="btn-main-link">
                            <img class="ico" src="../../assets/renew_pc/ico-google-play.png" alt="google play"/>
                            <span class="text">Google Play</span>
                        </a>
                    </div>
                </div>
                <button class="btn-section-mouse" @click="buttonMouse">
                    <img class="section-mouse" src="../../assets/renew_pc/img_mouse_arrow.png" alt="다음으로 이동">
                    <img class="mouse-arrow" src="../../assets/renew_pc/img_chevron_down.png" alt="다음으로 이동">
                </button>
            </div>
        

            <div class="section section2">
                <div class="copyright">
                    <div class="inner-div">
                        <strong class="copyright-text">
                            <span>왜 아직도</span>
                            <span class="copyright-ani">
                                <div class="ani">
                                    <div :ref="aniRef" class="ani-content">
                                        <span v-for="item in animatedTexts" :key="item.id">{{ item.text }}</span>
                                    </div>
                                </div>
                            </span>
                            <span>기다려야 하나요?</span>
                        </strong>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'hero',
    data() {
    return {
        currentIndex: 0,
        animatedTexts: [
            { id: 1, text: '병원에서' },
            { id: 2, text: '결제를' },
            { id: 3, text: '서류발급을' },
            { id: 4, text: '병원에서' }
        ],
        aniRef: 'aniDiv'
        };
    },
    methods: {
        startImageSlider() {
            setInterval(() => {
                this.currentIndex++;
                }, 4000);
        },

        buttonMouse() {
            let height = window.scrollY;
            let oneVhHeight = window.innerHeight;
            // let introduc01 = 3 * oneVhHeight;
            // let introduc02 = document.querySelector('.cont-introdu.cont-introduc02').getBoundingClientRect().top + window.scrollY + 200;
            // let introduc03 = document.querySelector('.cont-introdu.cont-introduc03').getBoundingClientRect().top + window.scrollY + 200;
            // let introduc04 = document.querySelector('.cont-introdu.cont-introduc04').getBoundingClientRect().top + window.scrollY + 1400;
            // let featureHeight = document.querySelector('#feature').getBoundingClientRect().top + window.scrollY - 200;

            let btnIntroMouse = document.querySelector('.btn-intro-mouse');
            // console.log(featureHeight)

            if (height < oneVhHeight) {
                this.scrollToPosition(oneVhHeight);
            } else {}
            
            // if (height >= oneVhHeight && height < introduc01) {
            //     this.scrollToPosition(introduc01);
            // }else if (height >= introduc01 && height < introduc02) {
            //     this.scrollToPosition(introduc02);
            // }else if (height >= introduc02 && height < introduc03) {
            //     this.scrollToPosition(introduc03);
            // }else if (height >= introduc03 && height < introduc04) {
            //     this.scrollToPosition(introduc04);
            // }else if (height >= introduc04 && height < featureHeight) {
            //     this.scrollToPosition(featureHeight);
            // }else {
            //     // document.querySelector('.btn-intro-mouse').style.disply = 'none';
            // }
        },
        scrollToPosition(position) {
        window.scrollTo({
            top: position,
            behavior: 'smooth'
        });
        },
        // handleScroll() {
        //     let oneVhHeight = window.innerHeight;
        //     let featureHeight = document.querySelector('#feature').getBoundingClientRect().top + window.scrollY - oneVhHeight;
        //     let btnIntroMouse = document.querySelector('.btn-intro-mouse');
        //     let scrollPosition = window.scrollY;

        //     if (scrollPosition > featureHeight) {
        //         btnIntroMouse.style.display = 'none';
        //     } else {
        //         btnIntroMouse.style.display = 'flex';
        //     }
        // }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    mounted: function()
    {
        window.addEventListener('scroll', this.handleScroll);

        $('html').animate({
            scrollTop: 0
        }, 100);
        this.startImageSlider();

        $(window).scroll(function() {
            updateSections();
        });

        function updateSections() {
            var vhHeight = window.innerHeight / 100;
            var oneVh = 100 * vhHeight;
            var oneVhHeight = 100 * vhHeight - 200;
            var twoVhHeight = 200 * vhHeight - 0;
            var height = $(document).scrollTop();
            // console.log(height);

            if (height < oneVhHeight) {
                updateDisplay(['.section1'], ['.section2'],'on');
                $('.section2').removeClass('on');
            } 
            else if (height >= oneVhHeight && height < twoVhHeight) {
                updateDisplay(['.section2'], ['.section1'], 'on');
                $('.section1').removeClass('on');
                $('.section-wrap').removeClass('off');
                $('.section2 .ani').addClass('start-ani');
            } 
            else if (height >= twoVhHeight + 0.1) {
                $('.section-wrap').addClass('off');
            }
        }

        function updateDisplay(showSelectors, hideSelectors, addClass) {
            $(showSelectors.join(', ')).css('display', 'inline-block').addClass(addClass);
            $(hideSelectors.join(', ')).css('display', 'none');
        }
    },
}
</script>

<style scoped>
    .hero{
        position: relative;
        width: 100%;
        /* height: 1932px; */
        height: 200vh;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        overflow: hidden;
    }

    .section-wrap{
        width: 100%;
        overflow: auto;
        height: 210vh;  
        overflow: hidden;
    }
    .section-wrap.off{
        overflow: inherit;
    }
    .section-wrap.off .section{
        position: relative;
        display: block !important;
    }
    .section{
        position: relative;
        display: block;
        width: 100%;
        height: 100vh;
        overflow: hidden;
    }
    .section.on{
        position: fixed;
        top: 0;
    }
    .section1::after{
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        background: url(../../assets/renew_pc/bg_barosoldoc01.jpg);
        z-index: -10;
    }
    .section-wrap.off .bg-video{
        position: absolute;
    }
    .section-wrap.off .video-area::after{
        position: absolute;
    }
    .section-wrap.off .title-wrap{
        position: relative;
    }
    .bg-video {
        position: absolute;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .video-area{
        z-index: -1;
    }
    .video-area::after{
        content: "";
        position: fixed;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.25);
    }
    .title-wrap{
        position: fixed;
        top: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        z-index: 1;
        transform: translateY(-50%);
    }
    .h-title{
        font-style: normal;
        font-weight: 200;
        color: #fff;
        text-align: center;
        animation: fadeInUp 1s;
    }
    .bold-title{
        font-size: 46px;
        font-weight: 600;
        line-height: 64px;
    }
    .sub-text{
        display: inline-block;
        margin-top: 14px;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 1.6;
    }

    .btn-group-area{
        display: flex;
        flex-direction: row;
        margin-top: 37px;
        animation: fadeInUp 1.25s;
    }
    .btn-main-link{
        min-width: 140px;
        height: 48px;
        display: flex;
        justify-content: space-around;
        align-items: center;   
        background: #293745;
        border-radius: 4px; 
        padding: 7px 18px;
        font-weight: 500;
        font-size: 16px;
        color: #fff;
    }
    .btn-main-link+.btn-main-link{
        margin-left: 10px;
    }
    .btn-main-link .ico+.text{
        margin-left: 10px;
    }
    .btn-main-link:hover{
        text-decoration: none;
    }
    .btn-section-mouse{
        position: absolute;
        left: 50%;
        bottom: 19px;
        transform: translate(-50%);
        display: flex;
        flex-direction: column;
        width: 24px;
        height: 62px;
        margin: 0;
        padding: 0;
        background: none;
        border: none;
        z-index: 20;
    }
    .section-mouse{
        position: relative;
        display: block;
        width: 24px;
        height: 38px;
        height: auto;
    }
    .mouse-arrow{
        display: block;
        width: 24px;
        height: 24px;
        transform-origin: 0px 0px;
        transform: translate(0, 0);
        animation: scroll-down 900ms ease-in-out infinite;
    }
    @keyframes scroll-down {
        0% {
        transform: translate(0, 3px);
        }
        30% {
        transform: translate(0, -2px);
        }       
        45% {
        transform: translate(0, 3px);
        }
        100% {
        transform: translate(0, 3px);
        }
    }

    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 100%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }

    .copyright{
        display: flex;
        justify-content: center;
        align-items: flex-start;
        min-width: 800px;
        /* min-height: 966px; */
        height: 100%;
        background: url(../../assets/renew_pc/bg_barosoldoc02.jpg);
        background-size: cover;
        background-repeat: no-repeat;
    }
    .inner-div {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
        height: 100%;
    }
    .copyright-text{
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 46px;
        font-weight: 500;
        text-align: center;
        color: #fff;
        animation: fadeInUp 1s;
    }
    .copyright-ani{
        position: relative;
        display: inline-flex;
        flex-direction: column;
        width: 250px;
        height: 69px;
        margin: 0 15px;
        font-size: 46px;
        line-height: 1.4;
        text-align: center;
        overflow: hidden;
    }
    .ani{
        position: absolute;
        /* animation: slideUp 6s linear infinite; */
    }
    .start-ani {
        animation: slideUp 12s linear infinite;
    }
    .ani-content {
        display: flex;
        flex-direction: column;
    }
    .ani-content span{
        display: inline-block;
        width: 250px;
        height: 1.48em;
        line-height: 1.5;
        text-align: center;
    }

    @keyframes slideUp {
        0%, 10% {
            top: 0;
        }
        25%, 40% {
            top: -1.48em;
        }
        55%, 70% {
            top: -2.96em;
        }
        85%, 99.98% {
            top: -4.44em;
        }
        99.99%, 100% {
            top: 0;
        }
    }

    .copyright-ani::before{
        position: absolute;
        left: 0;
        content: "[";
        font-weight: 400;
        color: #008DEF;
    }
    .copyright-ani::after{
        position: absolute;
        right: 0;
        content: "]";
        font-weight: 400;
        color: #008DEF;
    }
</style>


// WEBPACK FOOTER //
// src/components/pc_main/Hero.vue